import { DocumentNode, useMutation } from '@apollo/client';

import { graphql } from '../gql';

export const REMOVE_VENDOR_FROM_CONTACT = graphql(`
  mutation RemoveVendorFromContact($serviceInput: ServiceFilterInput!) {
    removeClaimVendorService(serviceInput: $serviceInput)
  }
`);

export interface RemoveVendorServiceInput {
  claimUuid: string;
  vendorUuid: string;
  serviceUuid: string;
}

export function useRemoveVendorFromContactMutation() {
  const [removeVendorMutation, { loading, error }] = useMutation(
    REMOVE_VENDOR_FROM_CONTACT as unknown as DocumentNode
  );

  const removeVendorFromContact = async (
    serviceInput: RemoveVendorServiceInput
  ) => {
    const response = await removeVendorMutation({
      variables: {
        serviceInput,
      },
    });
    return response.data?.removeClaimVendorService;
  };

  return {
    removeVendorFromContact,
    loading,
    error,
  };
}
